"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _deepmerge = _interopRequireDefault(require("deepmerge"));

var _PluginProvider = _interopRequireDefault(require("mirador/dist/es/src/extend/PluginProvider"));

var _App = _interopRequireDefault(require("mirador/dist/es/src/containers/App"));

var _createStore = _interopRequireDefault(require("mirador/dist/es/src/state/createStore"));

var _rootReducer = _interopRequireDefault(require("mirador/dist/es/src/state/reducers/rootReducer"));

var actions = _interopRequireWildcard(require("mirador/dist/es/src/state/actions"));

var _settings = _interopRequireDefault(require("mirador/dist/es/src/config/settings"));

var _selectors = require("mirador/dist/es/src/state/selectors");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _v = _interopRequireDefault(require("uuid/v4"));

require("./style.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var generateClassName = (0, _styles.createGenerateClassName)({
  productionPrefix: 'c',
  seed: "stories-api-mirador"
});
/**
* Mirador Viewer component.
*/

var Mirador =
/*#__PURE__*/
function (_Component) {
  _inherits(Mirador, _Component);

  function Mirador(props) {
    var _this;

    _classCallCheck(this, Mirador);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Mirador).call(this, props));
    var store = (0, _createStore.default)();
    _this.state = {
      store: store
    };

    _this.processConfig();

    return _this;
  }
  /**
   * Process config into actions
   */


  _createClass(Mirador, [{
    key: "processConfig",
    value: function processConfig() {
      var _this2 = this;

      var mergedConfig = (0, _deepmerge.default)(_settings.default, this.props.config);
      var action = actions.setConfig(mergedConfig);
      this.state.store.dispatch(action);
      mergedConfig.windows.forEach(function (miradorWindow, layoutOrder) {
        var windowId = "window-".concat((0, _v.default)());
        var manifestId = miradorWindow.manifestId || miradorWindow.loadedManifest;

        var manifestAction = _this2.state.store.dispatch(actions.fetchManifest(manifestId));

        var windowAction = _this2.state.store.dispatch(actions.addWindow(_objectSpread({
          // these are default values ...
          id: windowId,
          layoutOrder: layoutOrder,
          manifestId: manifestId,
          thumbnailNavigationPosition: mergedConfig.thumbnailNavigation.defaultPosition
        }, miradorWindow)));

        Promise.all([manifestAction, windowAction]).then(function () {
          if (miradorWindow.defaultSearchQuery) {
            var state = _this2.state.store.getState();

            var companionWindowId = (0, _selectors.getCompanionWindowIdsForPosition)(state, {
              position: 'left',
              windowId: windowId
            })[0];
            var searchService = (0, _selectors.getManifestSearchService)(state, {
              windowId: windowId
            });
            var searchId = searchService && "".concat(searchService.id, "?q=").concat(miradorWindow.defaultSearchQuery);
            companionWindowId && searchId && _this2.state.store.dispatch(actions.fetchSearch(windowId, companionWindowId, searchId, miradorWindow.defaultSearchQuery));
          }
        });
      });
      Object.keys(mergedConfig.manifests || {}).forEach(function (manifestId) {
        _this2.state.store.dispatch(actions.requestManifest(manifestId, mergedConfig.manifests[manifestId]));
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_styles.StylesProvider, {
        generateClassName: generateClassName
      }, _react.default.createElement(_styles.MuiThemeProvider, {
        theme: (0, _styles.createMuiTheme)()
      }, _react.default.createElement("div", {
        className: "story-mirador " + this.props.className,
        style: this.props.style
      }, _react.default.createElement(_reactRedux.Provider, {
        store: this.state.store
      }, _react.default.createElement(_PluginProvider.default, {
        plugins: this.props.plugins,
        createRootReducer: _rootReducer.default
      }, _react.default.createElement(_App.default, null))))));
    }
  }]);

  return Mirador;
}(_react.Component);

exports.default = Mirador;

_defineProperty(Mirador, "propTypes", {
  /** Set a classname of the mirador Component */
  className: _propTypes.default.string,

  /** Configuration options for the viewer */
  config: _propTypes.default.object,

  /** Specifiy any additional plugins to render */
  plugins: _propTypes.default.arrayOf(_propTypes.default.object)
});

_defineProperty(Mirador, "defaultProps", {
  config: {},
  plugins: []
});

;